import React from 'react';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import PropTypes from 'prop-types';
import NumberInput from '../../mylib/NumberInput';

export const SliderWithValue = ({ value, setValue }) => {
  const in_range = value >= -50 && value <= 50;
  return (
    <div
      className={'pl-2 pr-2'}
      style={{ display: 'inline-flex', width: '100%' }}
    >
      <Input
        className={'pl-2 pr-2'}
        style={{ opacity: in_range ? 1 : 0 }}
        type="range"
        name="range"
        min={-50}
        max={50}
        value={value}
        onChange={(v) => {
          if (in_range) {
            setValue(parseFloat(v.target.value));
          }
        }}
        id="exampleRange"
      />
      <InputGroup>
        <NumberInput
          id={'scale_frm_input'}
          className="form-control"
          min={-99}
          value={value}
          onChange={setValue}
        />
        <InputGroupAddon addonType="append">
          <InputGroupText>%</InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    </div>
  );
};

SliderWithValue.propTypes = {
  value: PropTypes.number,
  setValue: PropTypes.func,
};
